import { render, staticRenderFns } from "./ProductEditSellPrice.vue?vue&type=template&id=a6bcf5ee"
import script from "./ProductEditSellPrice.vue?vue&type=script&lang=ts"
export * from "./ProductEditSellPrice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6bcf5ee')) {
      api.createRecord('a6bcf5ee', component.options)
    } else {
      api.reload('a6bcf5ee', component.options)
    }
    module.hot.accept("./ProductEditSellPrice.vue?vue&type=template&id=a6bcf5ee", function () {
      api.rerender('a6bcf5ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductEditSellPrice.vue"
export default component.exports